@if (mobileWindow) {
  <div class="c-hamburger tw:pt-4" (click)="toggleSidebar()">
    @if (!sidebarToggled) {
      <i class="las la-bars"></i>
    }
    @if (sidebarToggled) {
      <i class="las la-times"></i>
    }
  </div>
}
<div id="sidenav" #sidebar class="sidenav" [class.sidenav--rail]="sidebarCollapsed">

  <div class="sidenav__header">
    <div class="sidenav__header-top">
      <div class="sidenav__brand">
        <img class="sidenav__brand-logo" src="assets/icons/Orbit_Icon_Full_Colour.png" alt="Supporting Education Group" />
        <div class="sidenav__brand-text">
          <span class="sidenav__brand-name">Supporting Education</span>
          <span class="sidenav__brand-sub">Group</span>
        </div>
      </div>
      <button class="sidenav__collapse" (click)="toggleCollapse()"
        [title]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
        [attr.aria-label]="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
        <i class="las" [ngClass]="sidebarCollapsed ? 'la-angle-double-right' : 'la-angle-double-left'"></i>
      </button>
    </div>
    <div class="sidenav__title">Tuition Management</div>
  </div>

  <ul class="sn__menu">
    @if (homeLinks.length > 1) {
      <li class="sn__menu-item sn__menu-item--l1 active" [routerLinkActive]="'section-active'">
        <a class="sn__menu-link" (click)="toggleMenuSelect('homeToggled')">
          <i class="las la-home"></i>
          <span>Home</span>
          <i class="las la-angle-down sn__caret" [ngClass]="homeToggled ? 'la-angle-up' : 'la-angle-down'"></i>
        </a>
        <ul class="sn__menu" [ngClass]="{ 'expanded' : homeToggled}">
          @for (home of homeLinks; track home.route) {
            <li class="sn__menu-item"><a [routerLink]="[home.route]" (click)="routeActivated()" [routerLinkActive]="'active'" class="sn__menu-link">{{home.label}}</a></li>
          }
        </ul>
      </li>
    } @else if (homeLinks.length === 1) {
      <li class="sn__menu-item sn__menu-item--l1">
        <a class="sn__menu-link" [routerLinkActive]="'active'"
          [routerLink]="[homeLinks[0].route]" (click)="routeActivated()">
          <i class="las la-home"></i>
          <span>Home</span>
        </a>
      </li>
    }
    @if (StudentSessionsView || SessionOverviewView || SessionSearchView || MissingSubmissionsView || ActionsView) {
      <li class="sn__menu-item sn__menu-item--l1" [routerLinkActive]="'section-active'">
        <a class="sn__menu-link" (click)="toggleMenuSelect('sessionsToggled')">
          <i class="las la-clipboard-list"></i>
          <span>Sessions</span>
          <i class="las la-angle-down sn__caret" [ngClass]="sessionsToggled ? 'la-angle-up' : 'la-angle-down'"></i>
        </a>
        <ul class="sn__menu" [ngClass]="{ 'expanded' : sessionsToggled}">
          <li class="sn__menu-item">
            @if (StudentSessionsView) {
              <a [routerLink]="['/tutorsessions']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Sessions Home
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (SessionOverviewView) {
              <a [routerLink]="['/overview']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Overview
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (SessionSearchView) {
              <a [routerLink]="['/search']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Session Search
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (MissingSubmissionsView) {
              <a [routerLink]="['/missing']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Missing Submissions
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (ActionsView) {
              <a [routerLink]="['/actions']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Pending Actions
              </a>
            }
          </li>
        </ul>
      </li>
    }
    @if (TcDashboardView || ViewStudentFeedbackDashboard || OnlineOverviewClient || OnlineOverviewAdmin) {
      <li class="sn__menu-item sn__menu-item--l1" [routerLinkActive]="'section-active'">
        <a class="sn__menu-link" (click)="toggleMenuSelect('managementToggled')">
          <i class="las la-chart-pie"></i>
          <span>Dashboard</span>
          <i class="las la-angle-down sn__caret" [ngClass]="managementToggled ? 'la-angle-up' : 'la-angle-down'"></i>
        </a>
        <ul class="sn__menu" [ngClass]="{ 'expanded' : managementToggled}">
          <li class="sn__menu-item">
            @if (TcDashboardView) {
              <a [routerLink]="['/tcdashboard']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Coordinator tasks
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (ViewStudentFeedbackDashboard) {
              <a [routerLink]="['/student-feedback-dashboard']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Learner Feedback
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (OnlineOverviewClient || OnlineOverviewAdmin) {
              <a [routerLink]="['/online-lesson-overview']" [routerLinkActive]="'active'"
                class="sn__menu-link" (click)="routeActivated()">
                Online Lesson Overview
              </a>
            }
          </li>
        </ul>
      </li>
    }
    <li class="sn__menu-item sn__menu-item--l1">
      @if (BookingSearchView) {
        <a class="sn__menu-link" [routerLinkActive]="'active'"
          [routerLink]="['/booking-search']" (click)="routeActivated()">
          <i class="las la-file-alt"></i>
          <span>{{themeService.siteContent.placementHeaderLabel == null || themeService.siteContent.placementHeaderLabel == '' ? '' : themeService.siteContent.placementHeaderLabel + 's'}}</span>
        </a>
      }
    </li>
    <li class="sn__menu-item sn__menu-item--l1">
      @if (ReportsView) {
        <a class="sn__menu-link" [routerLinkActive]="'active'"
          [routerLink]="['/reports']" (click)="routeActivated()">
          <i class="las la-file-alt"></i>
          <span>Reports</span>
        </a>
      }
    </li>
    <li class="sn__menu-item sn__menu-item--l1">
      @if (QaReportApprovalView) {
        <a class="sn__menu-link" [routerLinkActive]="'active'"
          [routerLink]="['/qa-report-approval']" (click)="routeActivated()">
          <i class="las la-check-double"></i>
          <span>QA Approval</span>
        </a>
      }
    </li>
    @if (ClientAdminEdit || UserMaintenanceView || RoleFeatureAdmin || ServiceProcessAdmin || FeatureSwitchAdmin || EmailTemplatesView || EmailHistoryView || LiveActivityView) {
      <li class="sn__menu-item sn__menu-item--l1" [routerLinkActive]="'section-active'">
        <a class="sn__menu-link" (click)="toggleMenuSelect('usersToggled')">
          <i class="las la-users"></i>
          <span>Admin</span>
          <i class="las la-angle-down sn__caret" [ngClass]="usersToggled ? 'la-angle-up' : 'la-angle-down'"></i>
        </a>
        <ul class="sn__menu" [ngClass]="{ 'expanded' : usersToggled}">
          <li class="sn__menu-item">
            @if (ClientAdminEdit) {
              <!-- "Client Users", not "Clients". This screen lists dbo.ClientUser - the people at a
                   client who log in to the portal - and not dbo.Clients, the schools and
                   organisations themselves. The route's own breadcrumb has always said Client Users;
                   only this link disagreed. Labelled "Clients" it reads as a list of clients that is
                   empty, which is how a working client cache gets reported as missing data. -->
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/clientadmin']" (click)="routeActivated()">
                <span>Client Users</span>
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (UserMaintenanceView) {
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/user-maintenance']" (click)="routeActivated()">
                <span>User Maintenance</span>
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (RoleFeatureAdmin) {
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/role-features']" (click)="routeActivated()">
                <span>Role Features</span>
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (ServiceProcessAdmin) {
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/service-processes']" (click)="routeActivated()">
                <span>System Controls</span>
              </a>
            }
          </li>
          <li class="sn__menu-item">
            @if (FeatureSwitchAdmin) {
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/feature-switches']" (click)="routeActivated()">
                <span>New Features</span>
              </a>
            }
          </li>
          @if (EmailTemplatesView) {
            <li class="sn__menu-item" *appFeatureSwitch="'emailtemplates.catalogue'">
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/email-templates']" (click)="routeActivated()">
                <span>Email templates</span>
              </a>
            </li>
          }
          @if (EmailHistoryView) {
            <li class="sn__menu-item" *appFeatureSwitch="'admin.email-history'">
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/email-history']" (click)="routeActivated()">
                <span>Email history</span>
              </a>
            </li>
          }
          @if (LiveActivityView) {
            <li class="sn__menu-item" *appFeatureSwitch="'admin.live-activity'">
              <a class="sn__menu-link" [routerLinkActive]="'active'"
                [routerLink]="['/live-activity']" (click)="routeActivated()">
                <span>Live activity</span>
              </a>
            </li>
          }
        </ul>
      </li>
    }
    @if (Student) {
      <li class="sn__menu-item sn__menu-item--l1">
        <a class="sn__menu-link" [routerLinkActive]="'active'"
          [routerLink]="['/feedback-survey']" (click)="routeActivated()">
          <i class="las la-file-alt"></i>
          <span>Your Voice</span>
        </a>
      </li>
    }
</ul>

<div class="sidenav__footer">
  <div class="sidenav__links">
    @if (!Student || isAdmin) {
      <a class="sidenav__safeguard" [href]="safeguardingUrl" target="_blank" rel="noopener"
        title="Raise a safeguarding concern">
        <i class="las la-shield-alt"></i>
        <span>Raise a safeguarding concern</span>
      </a>
    }
    <div class="sidenav__links-row">
      @for (link of footerLinks; track link.label) {
        @if (link.url) {
          <a class="sidenav__policy-link" [href]="link.url" target="_blank" rel="noopener">{{ link.label }}</a>
        } @else {
          <span class="sidenav__policy-link sidenav__policy-link--disabled" title="Coming soon">{{ link.label }}</span>
        }
      }
    </div>
  </div>
  <div class="sidenav__user">
    <div class="sidenav__user-badge">{{currentUserInitials}}</div>
    <div class="sidenav__user-body">
      <span class="sidenav__user-name">{{currentUserName}}</span>
      <span class="sidenav__user-role">{{currentUserRole}}</span>
      <span class="sidenav__user-email">{{currentUserEmail}}</span>
    </div>
    <div class="sidenav__user-actions">
      @if (AccountSettingsEdit) {
        <a [routerLink]="['/settings']" (click)="routeActivated()" title="Settings">
          <i class="las la-cog"></i>
        </a>
      }
      <a (click)="logout()" title="Logout">
        <i class="las la-sign-out-alt"></i>
      </a>
    </div>
  </div>
  <div class="sidenav__meta">
    <span class="sidenav__copyright">&copy; {{currentYear}} SEG. All rights reserved</span>
    <span class="sidenav__version">{{appVersion}}</span>
  </div>
</div>

</div>
